import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ic_checkbox",
  "use": "icon-ic_checkbox-usage",
  "viewBox": "0 0 44 44",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 44 44\" id=\"icon-ic_checkbox\"><rect stroke-width=\"2\" x=\"1\" y=\"1\" width=\"42\" height=\"42\" rx=\"4\" fill=\"#FFF\" stroke=\"#D4D4D4\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol